import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isNewbuildingFromBuilder: TComputedPropMapper<boolean> = ({ offer }): boolean => {
  const { newbuilding } = offer;

  return Boolean(newbuilding && newbuilding.isFromBuilder);
};
